export const caseTypes = [
  { ui_name: "9141", machine_name: "9141" },
  { ui_name: "9141C", machine_name: "9141C" },
  { ui_name: "9142B", machine_name: "9142B" },
  { ui_name: "9142C", machine_name: "9142C" },
  { ui_name: "790/790A", machine_name: "790A" },
  { ui_name: "9142A", machine_name: "9142A" },
  { ui_name: "9035", machine_name: "9035" },
];
export const caseTypesLookup = {
  9089: { ui_name: "9089", machine_name: "9089" },
  9141: { ui_name: "9141", machine_name: "9141" },
  "9141C": { ui_name: "9141C", machine_name: "9141C" },
  "9142B": { ui_name: "9142B", machine_name: "9142B" },
  "9142C": { ui_name: "9142C", machine_name: "9142C" },
  "790A": { ui_name: "790/790A", machine_name: "790A" },
  "9142A": { ui_name: "9142A", machine_name: "9142A" },
  9035: { ui_name: "9035", machine_name: "9035" },
};

export const caseStages = [
  { ui_name: "Initiated", machine_name: "Initiated" },
  { ui_name: "Pending Case Number", machine_name: "Presubmitted" },
  { ui_name: "Assigned Case Number", machine_name: "Submitted" },
  { ui_name: "Historical", machine_name: "Historical" },
  { ui_name: "Appeal", machine_name: "Appeal" },
  { ui_name: "Registration Numbers", machine_name: "RegistrationNumber" },
];

// used in cases filter slide out
export const caseStatuses = {
  9035: {
    "Assigned Case Number": ["In Process"],
    Historical: ["Certified", "Denied", "Withdrawn"],
  },
  9089: {
    "Assigned Case Number": [
      "Analyst Review",
      "RFI Issued",
      "Audit Review",
      "Audit - RFI Issued",
      "Pending Audit Response",
      "Supervised Recruitment",
      "SR - Correspondence Issued",
      "Application on Hold",
    ],
    Historical: [
      "Certified",
      "Certified - Expired",
      "Denied",
      "Denied - BALCA Affirmed",
      "Denied - BALCA Dismissed",
      "Withdrawn",
    ],
    Appeal: [
      "Reconsideration Appeals",
      "Reconsideration Appeals - RFI Issued",
      "Request for Review",
      "BALCA Appeals",
      "NORD Issued",
    ],
  },
  9141: {
    "Assigned Case Number": [
      "In Process",
      "Pending BALCA",
      "Pending Center Director Review",
      "Pending Redetermination",
      "RFI Issued",
    ],
    Historical: [
      "BALCA Affirmed",
      "BALCA Dismissed",
      "BALCA Overturned",
      "BALCA Remanded",
      "Center Director Review Affirmed Determination",
      "Center Director Review Modified Determination",
      "Determination Issued",
      "Redetermination Affirmed",
      "Redetermination Modified",
      "Returned Unprocessed",
      "Withdrawn",
    ],
  },
  "9142B": {
    "Assigned Case Number": [
      "Accepted - Pending Recruitment",
      "In Process",
      "NOD Issued",
      "Pending Appeal",
    ],
    Historical: [
      "Denied",
      "Full Certification",
      "NOR Issued",
      "Partial Certification",
      "Withdrawn",
    ],
    "Registration Numbers": ["Inactive"],
  },
  "9141C": {
    "Assigned Case Number": [
      "In Process",
      "Pending Center Director Review",
      "RFI Issued",
    ],
    Historical: [
      "Center Director Review Affirmed Determination",
      "Center Director Review Modified Determination",
      "Determination Issued",
      "Returned Unprocessed",
      "Withdrawn",
    ],
  },
  "9142C": {
    "Assigned Case Number": [
      "Accepted - Pending Recruitment",
      "In Process",
      "NOD Issued",
      "Pending Appeal",
    ],
    Historical: [
      "Denied",
      "Full Certification",
      "NOR Issued",
      "Partial Certification",
      "Withdrawn",
    ],
  },
  "790A": {
    "Assigned Case Number": [
      "Available For 9142A Linking",
      "In Process",
      "NOD Issued",
    ],
    Historical: ["Approved", "Denied", "Withdrawn"],
  },
  "9142A": {
    "Assigned Case Number": [
      "Accepted - Pending Recruitment",
      "In Process",
      "NOD Issued",
      "NRM Issued",
      "Pending Appeal",
    ],
    Historical: [
      "Denied",
      "Full Certification",
      "Full Certification - Expired",
      "Partial Certification",
      "Partial Certification - Expired",
      "Withdrawn",
    ],
  },
};
